<template>
  <div id="app">
    <!-- 导航 -->
    <navigation-top :list="list"></navigation-top>
    <router-view />
    <footer-category></footer-category>
  </div>
</template>
<script>
// import "@/assets/scss/iconfont.js";
import "@/assets/scss/iconfont.css";
import "@/assets/scss/short.css";
export default {
  name: "app",
  data() {
    return {
      // 导航
      list: []
    };
  },
  created() {
    this.$api.dispatch("nav.getNavs", 123).then(data => {
      this.list = data;
    });
  }
};
</script>
<style>
html,
body {
  padding: 0;
  margin: 0;
}
</style>
